import AnchoredPopoverController from "../../controllers/anchored_popover_base";
import "./component.scss";

// Behavior is inherited from AnchoredPopoverController; this component
// contributes its identifier (info-tooltip) and white-card SCSS.
export default class extends AnchoredPopoverController {}
